<div class="zoom-container">
    <div (click)="onChangeZoom($event, true)" class="zoom-action">-</div>
    <div class="zoom-value">{{displayValue}}</div>
    <div (click)="onChangeZoom($event, false)" class="zoom-action">+</div>
</div>